import { render, staticRenderFns } from "./SalesAccount.vue?vue&type=template&id=53deea3c&"
import script from "./SalesAccount.vue?vue&type=script&lang=js&"
export * from "./SalesAccount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports